import { render, staticRenderFns } from "./Blurb.vue?vue&type=template&id=6ff73b68&scoped=true&"
import script from "./Blurb.vue?vue&type=script&lang=ts&"
export * from "./Blurb.vue?vue&type=script&lang=ts&"
import style0 from "./Blurb.vue?vue&type=style&index=0&id=6ff73b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff73b68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6ff73b68', component.options)
    } else {
      api.reload('6ff73b68', component.options)
    }
    module.hot.accept("./Blurb.vue?vue&type=template&id=6ff73b68&scoped=true&", function () {
      api.rerender('6ff73b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/containers/Blurb.vue"
export default component.exports